import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "checked", "value", "onChange"];
import { useCallback } from 'react';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PanelCheckbox = _ref => {
  let {
      children,
      checked,
      value = '',
      onChange
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const simulatedOnChangeHandler = useCallback(() => {
    onChange({
      target: {
        checked: !checked,
        type: 'checkbox',
        value
      }
    });
  }, [checked, onChange, value]);
  return /*#__PURE__*/_jsx(View, {
    marginInlineStart: "500",
    children: /*#__PURE__*/_jsxs(Flex, Object.assign({
      alignItems: "center",
      borderBlockEndColor: "border-core-subtle",
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100",
      justifyContent: "space-between",
      onClick: simulatedOnChangeHandler,
      paddingBlock: "300",
      paddingInlineEnd: "500"
    }, restProps, {
      children: [children, /*#__PURE__*/_jsx("span", {
        style: {
          pointerEvents: 'none'
        },
        children: /*#__PURE__*/_jsx(Checkbox, {
          "aria-label": "checkbox",
          checked: checked
        })
      })]
    }))
  });
};